import { DbotEventDispatcher, DecisionContext, DecisionTypeHandler } from "../common/commonDomain";
import { ElectionOfCompanyBoard, ElectionOfCompanyBoardForm } from "./electionOfCompanyBoardDomain";
import { DecisionType } from "../../common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext,
  data?: ElectionOfCompanyBoard,
): ElectionOfCompanyBoardForm {
  return new ElectionOfCompanyBoardForm(dispatch, context, data);
}

export function isValid(form: ElectionOfCompanyBoardForm): boolean {
  return form.isValid;
}

export function validate(form: ElectionOfCompanyBoardForm): boolean {
  return form.validate();
}

export function applyForm(form: ElectionOfCompanyBoardForm): ElectionOfCompanyBoard {
  return {
    type: DecisionType.electionOfCompanyBoard,
    boardChanges: form.boardChanges.map((d) => d.toModel()),
    boardMeetingProtocolShowCompanyBoard: form.boardMeetingProtocolShowCompanyBoard.value ?? false,
    noticeGeneralMeetingShowCompanyBoard: form.noticeGeneralMeetingShowCompanyBoard.value ?? false,
    genderCompositionRequirement: form.genderCompositionRequirement.value ?? undefined,
  };
}

export const electionOfCompanyBoardHandler: DecisionTypeHandler<
  DecisionType.electionOfCompanyBoard,
  ElectionOfCompanyBoard,
  ElectionOfCompanyBoardForm
> = {
  type: DecisionType.electionOfCompanyBoard,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
